const DealListValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const dealCommonRequiredFields: string[] = [
    'name',
  ];

  const dealFileRequiredFields: string[] = [
    'name',
    'file',
  ];

  const dealFileGroupRequiredFields: string[] = [
    'name',
  ];

  if (values.dealListData) {
    if (!errors.dealListData) {
      errors.dealListData = {};
    }

    Object.keys(values.dealListData).forEach((dealIndex: string): void => {
      const dealData: ValidationEntityInput = {
        ...values.dealListData[dealIndex],
      };

      if (dealData) {
        if (!errors.dealListData[dealIndex]) {
          errors.dealListData[dealIndex] = {};
        }

        dealCommonRequiredFields.forEach((field: string): void => {
          if (!dealData[field] || !dealData[field].toString().trim()) {
            errors.dealListData[dealIndex][field] = 'Required';
          }
        });

        if (dealData.dealFile && Object.keys(dealData.dealFile).length) {
          if (!errors.dealListData[dealIndex].dealFile) {
            errors.dealListData[dealIndex].dealFile = {};
          }

          dealFileRequiredFields.forEach((field: string): void => {
            if (!dealData.dealFile[field] || !dealData.dealFile[field].toString().trim()) {
              errors.dealListData[dealIndex].dealFile[field] = 'Required';
            }
          });

          if (dealData.dealFile.group && Object.keys(dealData.dealFile.group).length) {
            if (!errors.dealListData[dealIndex].dealFile.group) {
              errors.dealListData[dealIndex].dealFile.group = {};
            }

            dealFileGroupRequiredFields.forEach((field: string): void => {
              if (!dealData.dealFile.group[field] || !dealData.dealFile.group[field].toString().trim()) {
                errors.dealListData[dealIndex].dealFile.group[field] = 'Required';
              }
            });
          } else if (!dealData.dealFile.groupId || !dealData.dealFile.groupId.toString().trim()) {
            errors.dealListData[dealIndex].dealFile.groupId = 'Required';
          }

          if (errors.dealListData[dealIndex].dealFile && !Object.keys(errors.dealListData[dealIndex].dealFile).length) {
            delete errors.dealListData[dealIndex].dealFile;
          }
        }

        if (errors.dealListData[dealIndex] && !Object.keys(errors.dealListData[dealIndex]).length) {
          delete errors.dealListData[dealIndex];
        }
      }
    });
  }

  if (errors.dealListData && !Object.keys(errors.dealListData).length) {
    delete errors.dealListData;
  }

  return errors;
};

export default DealListValidator;
